export default __webpack_public_path__ + "static/icon-3-3-840efe4e8850ec9a3ad1dc1b9fbc37dc.png";